"use strict";

import {isValid, loadParsley} from "@elements/parsley-bootstrap-validation";

export function initInScope($scope) {
    $scope.find('.js-form-with-overlay').on('submit', function (e) {
        let $form = $(this);
        loadParsley().then(function () {
            let valid = isValid($form);
            if(valid){
                $form.find('.js-loading__overlay').attr('hidden', false);
            }
        });
    });
}

